<template>
    <div :class="['page terms',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: infoFontColor }">
            
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'terms',
    mixins: [ pageOn ],
    computed: {
        pages () { return this.$store.state.pages },
        client_id () { return this.$store.state.client_id },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        infoFontColor () { return this.$store.state.infoFontColor },
        terms_id () { return this.$store.state.terms_id },
        terms () { return this.$store.state.terms }
    },
    components: {
        VHeader
    },
    mounted () {
        if ( this.terms ) {
            this.$el.querySelector('.page-content').innerHTML = this.terms;
        } else {
            WebSoc.SEND({ t: 'getTsCs', data: { client_id: this.client_id } },terms => {
                this.$el.querySelector('.page-content').innerHTML = terms;
            })
        }
    },
    methods: {
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
        
    }
}

</script>

<style lang="scss">

</style>